import { TableBasic } from "./TableBasic";
import { ExtractData, ExtractKeys } from "./TableHelpers";
import { TableBasicProps, TableObjectProps } from "./TableTypes";

/** Helper component that converts an object into a {@link TableBasic} */
export const TableObject = (props: TableObjectProps) => {

    const defaultProps: TableBasicProps = {
        ...props,
        columnTitles: ExtractKeys(props.object[0]),
        data: ExtractData(props.object),
    }

    return (
        <TableBasic {...defaultProps} />
    )
}